export const safeMessage = (message: unknown): string => {
  if (typeof message === "string") {
    // Check if it's a JSON CALL message and humanize it
    if (message.includes('"type":"CALL"') || message.includes('"type": "CALL"')) {
      return "Call";
    }
    return message;
  }
  if (typeof message === "number" || typeof message === "boolean")
    return String(message);
  return ""; // explicitly return empty string instead of null
};
